export const REGISTERED_CONSULTANT_EVENT = 'registerConsultant';

export interface RegisterConsultantEventData {
  consultantId: number;
  event: typeof REGISTERED_CONSULTANT_EVENT;
  registeredConsultantId: string;
  registrationType: string;
  sponsorNumber: string;
}
